import { render, staticRenderFns } from "./InvoiceCustomization.vue?vue&type=template&id=aa025826"
import script from "./InvoiceCustomization.vue?vue&type=script&lang=js"
export * from "./InvoiceCustomization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports